import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {type ChecklistDto, HrocChecklistsQueryKey} from '../../types'

const STALE_TIME_IN_MS = 1000 * 60 * 15

type ChecklistParams = {
  id: string
  plantId: string
}

export const useChecklist = (
  {id, plantId}: ChecklistParams,
  options?: Omit<UseQueryOptions<ChecklistDto, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const path = `/hroc-checklists/api/${plantId}/checklists/${id}`

  return useQuery<ChecklistDto, AxiosError>({
    queryKey: [HrocChecklistsQueryKey.Checklists, plantId, id],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ChecklistDto>(path, {signal})
      return response.data
    },
    staleTime: STALE_TIME_IN_MS,
    ...options
  })
}
